export enum ProjectTestOptions {
    Name = 1,
    Email = 2,
    PhoneNumber = 4,
    Identity = 8,
    SignWithCertificate = 16,
}

export default ProjectTestOptions;
